@if (state.isLoading()) {
  <span class="order-invoice">
    <app-horus-loader></app-horus-loader>
  </span>
} @else if (state.error()) {
  <span>❌ Error</span>
} @else {
  <div class="order-invoice"
    [ngClass]="state.isInvoiced() ? 'order-invoice--yes' : 'order-invoice--no'" >
    {{ state.isInvoiced() ? 'Sí' : 'No' }}
    @if (state.isInvoiced() && formattedDate()) {
      <span> ({{ formattedDate() }})</span>
    }
  </div>
}
